import React, { lazy } from 'react';

const CostCodeListing = lazy(() =>
  import('./CostCodeListing').then(module => ({
    default: module.CostCodeListing,
  })),
);

const CostCodeAssignment = lazy(() =>
  import('./CostCodeAssignment').then(module => ({
    default: module.CostCodeAssignment,
  })),
);

const CostCodeAssignmentListing = lazy(() =>
  import('./CostCodeAssignmentListing').then(module => ({
    default: module.CostCodeAssignmentListing,
  })),
);

const costCodeRoutes = [
  {
    props: {
      exact: true,
      path: '/:mode/general-settings/cost-code',
    },
    component: <CostCodeListing />,
  },
  {
    props: {
      exact: true,
      path: '/:mode/general-settings/cost-code-assignment',
    },
    component: <CostCodeAssignmentListing />,
  },
  {
    props: {
      exact: true,
      path: '/:mode/general-settings/cost-code-assignment/:projectID',
    },
    component: <CostCodeAssignment />,
  },
];

export default costCodeRoutes;
